<!-- src/components/InviteePopup.vue -->
<template>
  <div class="popup-overlay" v-if="isVisible">
    <div class="popup">
      <h2 class="popup-title">{{ invitee.firstName }} {{ invitee.lastName }}</h2>
      <form @submit.prevent="handleSubmit">
        <div class="input-group">
          <label>First Name</label>
          <input type="text" v-model="editableInvitee.firstName" required />
        </div>
        <div class="input-group">
          <label>Last Name</label>
          <input type="text" v-model="editableInvitee.lastName" required />
        </div>
        <div class="input-group">
          <label>Invitation Status</label>
          <select v-model="editableInvitee.status">
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
          </select>
        </div>
        <div class="input-group">
          <label>Table Number</label>
          <input type="number" v-model="editableInvitee.tableNumber" />
        </div>
        <div class="input-group">
          <label>Phone Number</label>
          <input type="text" v-model="editableInvitee.phoneNumber" />
        </div>
        <div class="input-group">
          <label>Email Address</label>
          <input type="email" v-model="editableInvitee.email" />
        </div>
        <div class="input-group">
          <label>Amount Donated</label>
          <input type="number" v-model="editableInvitee.donated" />
        </div>
        <div class="popup-buttons">
          <button type="button" @click="cancel" class="cancel-btn">Cancel</button>
          <button type="submit" class="ok-btn">OK</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invitee: {
      type: Object,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      editableInvitee: { ...this.invitee },
    };
  },
  methods: {
    handleSubmit() {
      this.$emit("update", this.editableInvitee);
      this.close();
    },
    cancel() {
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup {
  background-color: #002244;
  padding: 2rem;
  border-radius: 8px;
  width: 400px;
  color: white;
}

.popup-title {
  color: #ff6b35;
  margin-bottom: 1rem;
}

.input-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 0.3rem;
}

input[type="text"],
input[type="email"],
input[type="number"],
select {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
}

.popup-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.cancel-btn {
  background-color: #ff6b35;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  cursor: pointer;
}

.ok-btn {
  background-color: #00cfff;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  cursor: pointer;
}
</style>
